'use client';

import { Typography } from '@musinsa/mds';
import { useStaticHtmlContent } from '../hooks/useStaticHtmlContent';
import {
  AGREEMENT_UI_TEXT,
  type AgreementBrand,
  type AgreementType,
  getAgreementHtmlPath,
  getPreviousVersion,
} from '../utils/agreementVersions';
import { HtmlContentRenderer } from './HtmlContentRenderer';

interface AgreementContentProps {
  type: AgreementType;
  brand: AgreementBrand;
  version?: string;
  onPreviousClick: () => void;
}

export const AgreementContent = ({
  type,
  brand,
  version,
  onPreviousClick,
}: AgreementContentProps) => {
  const htmlPath = getAgreementHtmlPath(type, brand, version);
  const { htmlContent, isLoading, error } = useStaticHtmlContent(htmlPath);
  const hasPrevious = getPreviousVersion(type, brand, version) !== null;

  if (isLoading) {
    return (
      <Typography variant="body13pxReg" colorScheme="gray-600">
        약관을 불러오는 중입니다.
      </Typography>
    );
  }

  if (error || !htmlContent) {
    return (
      <Typography variant="body13pxReg" colorScheme="gray-600">
        약관을 불러오는데 실패했습니다.
      </Typography>
    );
  }

  return (
    <div className="safe-area-bottom">
      <HtmlContentRenderer html={htmlContent} />
      {hasPrevious && (
        <Typography variant="body13pxReg" asChild>
          <button type="button" onClick={onPreviousClick} className="text-[13px]" role="link">
            {AGREEMENT_UI_TEXT[type].prevButton}
          </button>
        </Typography>
      )}
    </div>
  );
};
